import styled from 'styled-components'

import { Table, Thead, Tr, Th } from '@/components/elements/Table'

import type { StockDividendProps } from '@/types/stockDividend'

export const DividendTable = ({ items }: StockDividendProps) => {
  const maxLength = 5
  const displayItems = items.slice(0, maxLength).reverse();

  return (
    <Wrapper>
      <section>
        <Table>
          <Thead>
            <Tr>
              <Th color={'secondary'}></Th>
              {displayItems.map((item, index) => (
                <Th
                  key={index}
                  color={'secondary'}
                  textAlign="center"
                >
                  {item.year}年6月期
                </Th>
              ))}
            </Tr>
            <Tr>
              <Th color={'tertiary'} textAlign="left">
                年間配当金（円）
              </Th>
              {displayItems.map((item, index) => (
                <Th
                  key={index}
                  color={'quaternary'}
                  textAlign="right"
                >
                  {Number(item.value).toFixed(1)}
                  {item.isForecast ? '(予想)' : ''}
                </Th>
              ))}
            </Tr>
          </Thead>
        </Table>
      </section>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media screen and (max-width: 1047px) {
    gap: 6px;
  }

  table {
    table-layout: fixed;
    min-width: 800px;
  }

  tr th:first-child {
    position: sticky;
    left: 0;
    width: 20%;
  }
`
